export default __webpack_public_path__ + "static/media/litho-demo-seo-agency.cef69d18.jpg";